import Head from 'next/head'

import ContactForm from '@/components/PaymentVer2/ContactForm'
import Customer from '@/components/PaymentVer2/Customer'
import FaQ from '@/components/PaymentVer2/FaQ'
import Footer from '@/components/PaymentVer2/Layout/Footer'
import Header from '@/components/PaymentVer2/Layout/Header'
import Partner from '@/components/PaymentVer2/Partner'
import { Step } from '@/components/PaymentVer2/Step'
import Tutorial from '@/components/PaymentVer2/Tutorial'
import { Why } from '@/components/PaymentVer2/Why'

const productPath = process.env.NEXT_PUBLIC_REACT_APP_PRODUCTION_PATH

export default function Home() {

  return (<>
    <Head>
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width,initial-scale=1.0" />

      <title>
        KiotViet Finance - Giải Pháp thanh toán và vay vốn tiện lợi
      </title>
      <meta
        name="title"
        content="KiotViet Finance - Giải Pháp thanh toán và vay vốn tiện lợi"
      />
      <meta
        name="description"
        content="Giải pháp tài chính cho doanh nghiệp vừa, nhỏ và siêu nhỏ hỗ trợ bạn phát triển và mở rộng kinh doanh."
      />

      {/* <!-- Open Graph / Facebook --/> */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={productPath || '/'} />
      <meta
        property="og:title"
        content="KiotViet Finance - Giải Pháp thanh toán và vay vốn tiện lợi"
      />
      <meta
        property="og:description"
        content="Giải pháp tài chính cho doanh nghiệp vừa, nhỏ và siêu nhỏ hỗ trợ bạn phát triển và mở rộng kinh doanh."
      />
      <meta
        property="og:image"
        content={`${productPath || ''}/images/preview-img.png`}
      />
    </Head>
    <Header />
    <div>
      <Step />
      <Why />
      <Customer />
      <Partner />
      <Tutorial />
      <ContactForm />
      <FaQ />
    </div>
    <Footer />
  </>)
}
